import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import * as styles from "./splash.module.css";

const Splash = () => {
  return (
    <section id="splash">
      <div className={styles.splashBackground}>
        <StaticImage
          className={styles.backgroundImage}
          src="../../images/splash.jpg"
          alt="Background image"
          placeholder="blurred"
        />
        <div className={styles.textOverlay}>
          <h1 className={styles.splashText}>Milky Haze</h1>
        </div>
      </div>
    </section>
  );
};

export default Splash;
